import { BaseRepository } from '../../infra/base.repository'
import { ConfigService } from '../../infra/config'
import type { Comission } from './comission'

export class ComissionsRepository extends BaseRepository<Comission> {
    constructor(
        private config: ConfigService = new ConfigService(),
        token?: string,
        cache?: any,
    ) {
        super(config.eventApiUrl + '/comissions', token, cache)
    }
}
